import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import './styles/theme.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out the Novalink loading screen from index.html once the app has painted,
// keeping it up long enough for the logo animation to finish.
const SPLASH_MIN_MS = 1600;
const splash = document.getElementById('nb-splash');
if (splash) {
  const wait = Math.max(0, SPLASH_MIN_MS - performance.now());
  setTimeout(() => {
    requestAnimationFrame(() => {
      splash.classList.add('is-done');
      setTimeout(() => splash.remove(), 550);
    });
  }, wait);
}
